import { render, staticRenderFns } from "./8.vue?vue&type=template&id=c9437c7c&scoped=true&"
import script from "./8.vue?vue&type=script&lang=js&"
export * from "./8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9437c7c",
  null
  
)

export default component.exports